import React from "react";
import styled, { css } from "styled-components";
import fadeInSlideIn from "../../../animations/fadeInSlideIn";
import OnColorContext from "../../../contexts/OnColorContext";
var ThinX = function ThinX(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.692 2.795a1.051 1.051 0 1 0-1.487-1.487L8 6.513 2.795 1.308a1.052 1.052 0 0 0-1.487 1.487L6.513 8l-5.205 5.205a1.052 1.052 0 1 0 1.487 1.487L8 9.487l5.205 5.205a1.051 1.051 0 1 0 1.487-1.487L9.487 8l5.205-5.205Z"
  }));
};
ThinX.defaultProps = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { animationDuration, zIndex } from "../../../settings";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import ButtonAtm from "../../atoms/ButtonAtm";
import IconButtonAtm from "../../atoms/IconButtonAtm";
import LinkAtm from "../../atoms/LinkAtm";
import TextAtm from "../../atoms/TextAtm";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import PushOrg from "../../organisms/PushOrg";
var background = "backgroundLight";
var breakpointValue = "large";
var wrapperPositionSpace = 2;
var wrapperWidthOnMediumSpace = 56;
var Wrapper = styled.div.withConfig({
  componentId: "sc-12qc05q-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["position:fixed;z-index:", ";right:0;bottom:0;padding:", ";background:", ";", "{left:0;animation:", " ", "s forwards;border-top:", " solid ", ";}", "{right:", ";bottom:", ";left:auto;max-width:", ";padding:", ";border-radius:", ";box-shadow:", ";}"], zIndex.CookieMol, space(2), getColor(theme, background), breakpoint("small", breakpointValue), fadeInSlideIn(), animationDuration.slow / 1000, unit(1), getBorderColor(theme, background, "low"), breakpoint(breakpointValue), space(wrapperPositionSpace), space(wrapperPositionSpace), space(wrapperWidthOnMediumSpace), space(3), getBorderRadius(theme, "large"), getBoxShadow(theme, "small"));
});
var Header = styled.div.withConfig({
  componentId: "sc-12qc05q-1"
})(["display:flex;"]);
var Title = styled(TextAtm).withConfig({
  componentId: "sc-12qc05q-2"
})(["flex-grow:1;margin-right:", ";"], space(2));
function CookieMol(_ref2) {
  var title = _ref2.title,
    text = _ref2.text,
    link = _ref2.link,
    close = _ref2.close;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: background
  }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(Title, {
    typography: "medium3_s",
    pushSpace: 1
  }, title), /*#__PURE__*/React.createElement(IconButtonAtm, {
    icon: ThinX,
    sizeSpace: 2,
    emphasis: "medium",
    onClick: close.onClick
  })), /*#__PURE__*/React.createElement(TextAtm, {
    typography: "small1",
    pushSpace: 1
  }, text), /*#__PURE__*/React.createElement(LinkAtm, {
    to: link.to,
    href: link.href,
    title: link.title,
    onClick: link.onClick
  }, link.text), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "large"
  }, /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 3,
    hasNoReset: true
  }, /*#__PURE__*/React.createElement(ButtonAtm, {
    onClick: close.onClick,
    title: close.title,
    isExpanded: true
  }, close.text)))));
}
export default CookieMol;